var _circle, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityWideTournamentFeeder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 15.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 23V19H34.5M45 30.5V35.5H34.5M34.5 46H45.5V50.5M45.5 57.5V63H34.5M52.5 27H62V37M62 44.5V54H52.5",
    stroke: "#103B5D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 42.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 31.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 58.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 23.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 37.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 50.5,
    width: 15,
    height: 7,
    fill: "#103B5D",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityWideTournamentFeeder);
export default __webpack_public_path__ + "static/media/City_wide_tournament_feeder.2bc20d9802af562d1ff72c65b4b49acd.svg";
export { ForwardRef as ReactComponent };